import {
  ActivitiesPageSetup,
  AllowedAppsPageSetup,
  FunctionPermissionsPageSetup,
  ConfigPageSetup,
  ContactsPageSetup,
  DoctorContactsPageSetup,
  EmergencyContactsPageSetup,
  GeofencesPageSetup,
  MedicalPageSetup,
  MemoriesPageSetup,
  AllergiesPageSetup,
  HealthHistoryPageSetup,
  TestResultsPageSetup,
  MedicationsPageSetup,
  ProfilePageSetup,
} from '~/pages/setup';
import { MyProfilePage } from '~/pages/account';
import { IRouteModel } from '../interface/common';

export const setupRoute = {
  base: '/setup',
  config: '/config',
  allowedApps: '/config/allowed-apps',
  functionPermissions: '/config/function-permissions',
  profile: '/profile',
  contacts: '/contacts',
  activities: '/activities',
  memories: '/memories',
  medical: '/medical',
  medications: '/medical/medications',
  allergies: '/medical/allergies',
  healthHistory: '/medical/health-history',
  testResults: '/medical/test-results',
  doctorContacts: '/medical/doctors',
  emergencyContacts: '/medical/emergency-contacts',
  geofences: '/geofences',
  myProfile: '/my-profile',
};

export const setupRouteAbsolute = Object.fromEntries(
  Object.entries(setupRoute).map(([key, path]) => [key, key === 'base' ? path : `${setupRoute.base}${path}`])
) as typeof setupRoute;

export interface ISetupRouteModel extends IRouteModel {
  // Permission module key (camelCase, as returned by GET /users/profile) an
  // other-admin needs `view` on to see the tab; a senior admin sees every tab.
  // undefined: not gated by a permission module in the app, so any web caregiver sees it
  module?: string;
  // Senior Medical sections are gated one by one (the app's manageAllergy, manageDoctorContact...)
  action?: string;
  // false: reachable (from the Medical page) but not listed in the sidebar
  inNav?: boolean;
}

// `name` holds an i18n key (nav.*) - Sidebar renders it via t().
export const privateSetupRoutes: ISetupRouteModel[] = [
  { path: setupRouteAbsolute.profile, component: ProfilePageSetup, name: 'nav.setup.profile', module: 'seniorProfile' },
  { path: setupRouteAbsolute.contacts, component: ContactsPageSetup, name: 'nav.setup.contacts', module: 'contact' },
  { path: setupRouteAbsolute.activities, component: ActivitiesPageSetup, name: 'nav.setup.activities', module: 'event' },
  { path: setupRouteAbsolute.memories, component: MemoriesPageSetup, name: 'nav.setup.memories', module: 'photo' },
  { path: setupRouteAbsolute.medical, component: MedicalPageSetup, name: 'nav.setup.medical', module: 'seniorMedical' },
  {
    path: setupRouteAbsolute.medications,
    component: MedicationsPageSetup,
    name: 'nav.setup.medications',
    module: 'seniorMedical',
    action: 'manageMedication',
    inNav: false,
  },
  {
    path: setupRouteAbsolute.allergies,
    component: AllergiesPageSetup,
    name: 'nav.setup.allergies',
    module: 'seniorMedical',
    action: 'manageAllergy',
    inNav: false,
  },
  {
    path: setupRouteAbsolute.healthHistory,
    component: HealthHistoryPageSetup,
    name: 'nav.setup.healthHistory',
    module: 'seniorMedical',
    action: 'manageHealthHistory',
    inNav: false,
  },
  {
    path: setupRouteAbsolute.testResults,
    component: TestResultsPageSetup,
    name: 'nav.setup.testResults',
    module: 'seniorMedical',
    action: 'manageTestResult',
    inNav: false,
  },
  {
    path: setupRouteAbsolute.emergencyContacts,
    component: EmergencyContactsPageSetup,
    name: 'nav.setup.emergencyContacts',
    module: 'seniorMedical',
    action: 'manageDoctorNote',
    inNav: false,
  },
  {
    path: setupRouteAbsolute.doctorContacts,
    component: DoctorContactsPageSetup,
    name: 'nav.setup.doctorContacts',
    module: 'seniorMedical',
    action: 'manageDoctorContact',
    inNav: false,
  },
  // the signed-in user's own account (not the senior's profile): reached from the header menu
  { path: setupRouteAbsolute.myProfile, component: MyProfilePage, name: 'nav.profile', inNav: false },
  { path: setupRouteAbsolute.geofences, component: GeofencesPageSetup, name: 'nav.setup.geofences' },
  {
    path: setupRouteAbsolute.allowedApps,
    component: AllowedAppsPageSetup,
    name: 'nav.setup.allowedApps',
    module: 'seniorPhoneSetup',
    inNav: false,
  },
  {
    path: setupRouteAbsolute.functionPermissions,
    component: FunctionPermissionsPageSetup,
    name: 'nav.setup.functionPermissions',
    module: 'seniorPhoneSetup',
    inNav: false,
  },
  { path: setupRouteAbsolute.config, component: ConfigPageSetup, name: 'nav.setup.config', module: 'seniorPhoneSetup' },
];
